import { render } from "./SurvivorGamePage.vue?vue&type=template&id=89a0f51e&scoped=true"
import script from "./SurvivorGamePage.vue?vue&type=script&lang=js"
export * from "./SurvivorGamePage.vue?vue&type=script&lang=js"

import "./SurvivorGamePage.vue?vue&type=style&index=0&id=89a0f51e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a0f51e"]])

export default __exports__